AFRAME.registerComponent('main-settings', {
    schema: {
        themeMode: { type: 'string', default: 'Dark' },
        stockBarsTextures: { type: 'boolean', default: false },
        view: { type: 'string', default: 'VR' },
        quality: { type: 'string', default: '' },
        bgPanelsShow: { type: 'boolean', default: true },
        autoRotatePanels: { type: 'boolean', default: true },
        isETTimeZone: { type: 'boolean', default: true },
        skipIntroPage: { type: 'boolean', default: false },
    },

    DEVICE_INVERT_KEY: 'vr_invertMouseCamera',

    _loadInvertMouseCamera: function () {
        try {
            if (typeof getCacheItem === 'function') {
                const val = getCacheItem(this.DEVICE_INVERT_KEY);
                return val || { x: false, y: false };
            }
        } catch (e) {
            return { x: false, y: false };
        }
    },

    _saveInvertMouseCamera: function (value) {
        try {
            const expiry = typeof CACHE_EXPIRATION !== 'undefined'
                ? CACHE_EXPIRATION.PERSISTENT
                : 5256000;
            if (typeof setCacheItem === 'function') {
                setCacheItem(this.DEVICE_INVERT_KEY, value, expiry);
            }
        } catch (e) {
            console.warn('[MainSettings] Failed to save invertMouseCamera', e);
        }
    },

    init: function () {
        console.log('MainSettings Component: init called');
        
        try {
            if (typeof setCacheItem === 'function') {
                setCacheItem('preferred-page', 'vr', 60 * 60 * 24 * 30);
            } else {
                localStorage.setItem('preferred-page', JSON.stringify({ value: 'vr', expiry: Date.now() + 60 * 60 * 24 * 30 * 1000 }));
            }
        } catch (e) {
            console.warn('Failed to set preferred-page in cache', e);
        }

        this._initVariables();

        this.STORAGE_KEY = 'mainSettings';
        this.PANEL_POSITIONS_KEY = 'userPanelPositions';
        this.EXPIRATION_TIME = typeof CACHE_EXPIRATION !== 'undefined' ? CACHE_EXPIRATION.PERSISTENT : 5256000;



        const stored = this._loadSettings();


        if (stored) {
            const toApply = {};
            Object.keys(this.schema).forEach((key) => {
                if (Object.prototype.hasOwnProperty.call(stored, key)) {
                    toApply[key] = stored[key];
                }
            });
            if (Object.keys(toApply).length) {
                this.el.setAttribute('main-settings', toApply);
            }
        } else {
            this._saveSettings();
        }

        // Defer visual updates until scene is loaded to ensure all target elements exist
        if (this.el.sceneEl.hasLoaded) {
            this.onSceneLoaded();
        } else {
            this.el.sceneEl.addEventListener('loaded', this.onSceneLoaded.bind(this));
        }

        this.attachExternalListeners();

        if (window.PopupManager) {
            window.PopupManager.register('main-settings-popup', this.el);
        }
    },

    onSceneLoaded: function () {
        console.log('MainSettings: Scene loaded, applying settings...');
        // Re-init variables in case some elements were created dynamically after init
        this._initVariables();

        this.applySettings();
        this.replaceModelsToSuitTheme();
        this.suitsTexOfDockPanelForCurrentTheme();

        this._restorePositionsFromCache();
        this.handleClickFixedButton();

        // Listen for watchlist view changes to update handles if needed
        this.el.sceneEl.addEventListener('watchlist-show-chart', this.onWatchlistViewChanged.bind(this));
        this.el.sceneEl.addEventListener('watchlist-show-table', this.onWatchlistViewChanged.bind(this));

        this.el.sceneEl.addEventListener('chart-type-changed', this._updateCentralHandlePosition.bind(this));
        this.el.sceneEl.addEventListener('mmap-mode-changed', this._updateCentralHandlePosition.bind(this));
    },

    onWatchlistViewChanged: function () {
        if (this.isRepositioning) {
            // Re-evaluate handle visibility (e.g. show/hide chart or table handle)
            // waiting for the DOM to update visibility first?
            // usually the event is emitted after visibility set? 
            // switch-table-chart.js emits after setting visible.
            this.handleClickManualButton();
        }
    },

    attachExternalListeners: function () {
        const settingsButton = document.querySelector('#settings-button');
        if (settingsButton) {
            settingsButton.addEventListener('click', () => {
                console.log('Settings button clicked');
                if (window.PopupManager) {
                    window.PopupManager.open('main-settings-popup');
                } else {
                    this.open();
                    this.el.setAttribute('visible', true);
                }
                if (window.gtag) gtag('event', `VR_TopNav_SettingsMenu`);
            });
        } else {
            console.warn('Settings button not found');
        }
    },

    _initVariables: function () {
        this.moveRightPanelArea = document.querySelector('#move-right-panel-area');
        this.moveLeftPanelArea = document.querySelector('#move-left-panel-area');
        this.moveDockArea = document.querySelector('#move-dock-area');
        this.moveCentralPanelArea = document.querySelector('#move-central-panel-area');
        this.moveTopMenuArea = document.querySelector('#move-top-menu-area');
        this.moveChartTypeArea = document.querySelector('#move-chart-type-area');

        this.rightPanel = document.querySelector('#right-container');
        this.leftPanel = document.querySelector('#left-panel-2');
        this.dock = document.querySelector('#dock');
        this.centralPanel = document.querySelector('#large-center-panel');
        this.topMenu = document.querySelector('#top-menu-container');
        this.chartType = document.querySelector('#chart-type-control'); // Corrected ID

        // Search Panel References (Dynamic, might not exist yet but we try)
        this.searchPanel = document.querySelector('#search-center-panel');
        this.moveSearchPanelArea = document.querySelector('#move-search-panel-area');

        // Watchlist Table References
        this.watchlistTable = document.querySelector('#watchlist-table');
        this.moveWatchlistTableArea = document.querySelector('#move-watchlist-table-area');

        this.bgPanels = document.querySelector('#background-panels');
        this.skyboxSphere = document.getElementById('skybox-sphere');

        this.popupBgDark = this.el.querySelector('.background-panel-dark');
        this.popupBgLight = this.el.querySelector('.background-panel-light');

        this.isRepositioning = false;
    },

    _loadSettings: function () {
        try {
            const data = getCacheItem(this.STORAGE_KEY);
            console.log('Loaded main settings from cache:', data);
            return data;
        } catch (e) {
            console.warn('Failed to load main settings', e);
            return null;
        }
    },

    _saveSettings: function () {
        try {
            const payload = {};
            Object.keys(this.schema).forEach((key) => {
                payload[key] = this.data[key];
            });
            setCacheItem(this.STORAGE_KEY, payload, this.EXPIRATION_TIME);

            // Extra save to configureControlSettings
            if (this.data.stockBarsTextures !== undefined) {
                const configureSettings = getCacheItem('configureControlSettings') || {};
                configureSettings.stockBarsTextures = this.data.stockBarsTextures;
                setCacheItem('configureControlSettings', configureSettings, this.EXPIRATION_TIME);
                console.log('Saved stockBarsTextures to configureControlSettings:', this.data.stockBarsTextures);
            }
        } catch (e) {
            console.warn('Failed to save main settings', e);
        }
    },

    createHeader: function () {
        // Create container for header elements if it doesn't exist
        let headerContainer = this.el.querySelector('#main-settings-header');
        if (!headerContainer) {
            headerContainer = document.createElement('a-entity');
            headerContainer.setAttribute('id', 'main-settings-header');
            this.el.appendChild(headerContainer);
        }
        headerContainer.innerHTML = ''; // Clear existing header content

        const isLight = this.data.themeMode === 'Light';
        const txtColor = isLight ? '#14141C' : '#FFFFFF';

        // main text
        const title = document.createElement('a-troika-text');
        title.setAttribute('value', 'Settings');
        title.setAttribute('font-size', 0.03);
        title.setAttribute('color', txtColor);
        title.setAttribute('anchor', 'center');
        title.setAttribute('position', `0 0.55 0.01`)
        headerContainer.appendChild(title);

        // close button
        const cross = document.createElement('a-troika-text');
        cross.setAttribute('value', '×');
        cross.setAttribute('font-size', 0.04);
        cross.setAttribute('color', txtColor);
        cross.setAttribute('anchor', 'center');
        cross.setAttribute('position', `0.26 0.55 0.01`)
        headerContainer.appendChild(cross);

        // clickable area
        const interactivePlane = document.createElement('a-plane');
        interactivePlane.setAttribute('id', 'close-main-settings-popup');
        interactivePlane.setAttribute('height', 0.04);
        interactivePlane.setAttribute('width', 0.04);
        interactivePlane.setAttribute('position', `0.26 0.55 0.01`);
        interactivePlane.setAttribute('opacity', '0');
        interactivePlane.setAttribute('data-raycastable', '');
        interactivePlane.addEventListener('click', () => {
            console.log('MainSettings: Close clicked');
            if (window.PopupManager) {
                window.PopupManager.close('main-settings-popup');
            } else {
                this.close();
            }
        })
        headerContainer.appendChild(interactivePlane);
    },

    createSettingsList: function () {
        console.log('MainSettings: createSettingsList called');
        const { stockBarsTextures, themeMode, view, quality } = this.data;

        const contentElement = this.el.querySelector('#main-settings-content');
        if (!contentElement) {
            console.warn('main-settings-content entity not found');
            return;
        }
        contentElement.innerHTML = '';

        const itemWidth = 0.56;
        const itemHeight = 0.06; // Standard single-row height
        const complexHeight = 0.14; // Height for Mode/View/Repo blocks
        const padding = 0.02; // Gap between items

        let currentY = -0.1;

        // Helper to place and advance
        const addBlock = (element, height) => {
            element.setAttribute('position', `${-itemWidth / 2} ${currentY} 0`);
            contentElement.appendChild(element);
            currentY -= (height + padding);
        };

        const createStandardItemContainer = () => {
            const el = document.createElement('a-entity');
            // Position will be set by addBlock
            return el;
        };

        const isLight = this.data.themeMode === 'Light';
        const txtColor = isLight ? '#14141C' : '#FFFFFF';
        const itemBgColor = isLight ? '#000' : '#fff';
        const itemBgOpacity = isLight ? '0.05' : '0.1';

        // // 1. Account Management (Standard)
        // const accountContainer = createStandardItemContainer();
        //
        // const accountBg = document.createElement('a-rounded-plane');
        // accountBg.setAttribute('height', itemHeight);
        // accountBg.setAttribute('width', itemWidth);
        // accountBg.setAttribute('radius', '0.01');
        // accountBg.setAttribute('color', isLight ? '#1e1e1e' : '#fff');
        // accountBg.setAttribute('opacity', '0.02');
        // accountBg.setAttribute('position', `0 ${-itemHeight / 2} 0.002`);
        // accountContainer.appendChild(accountBg);
        //
        // const accountLabel = document.createElement('a-troika-text');
        // accountLabel.setAttribute('value', 'Account Management');
        // accountLabel.setAttribute('font-size', 0.02);
        // accountLabel.setAttribute('color', txtColor);
        // accountLabel.setAttribute('anchor', 'left');
        // accountLabel.setAttribute('position', `${padding} 0 0.01`);
        // accountContainer.appendChild(accountLabel);
        //
        // const accountBtn = document.createElement('a-entity');
        // accountBtn.setAttribute("ui-button", {
        //     image: "#arrow-right-wide-icon",
        //     colorScheme: "tertiary",
        //     width: 0.08,
        //     height: 0.04,
        //     depth: 0.005,
        //     type: "rounded-box",
        //     radius: 0.01,
        //     preferredFontSize: 0.03,
        // });
        // accountBtn.setAttribute('position', `${itemWidth - 0.05} 0 0.01`);
        // accountBtn.addEventListener('click', () => {
        //     const accountButton = document.querySelector('#top-menu-container .auth-button');
        //     if (!accountButton) return
        //     if (accountButton.hasAttribute('data-raycastable')) {
        //         if (window.AuthUI.showMessage && typeof window.AuthUI.showMessage === 'function') {
        //             window.AuthUI.showMessage('Please sign in to manage your account and linked devices.');
        //         }
        //         return
        //     }
        //
        //     if (window.PopupManager) {
        //         window.PopupManager.open('account-management-pop-up');
        //     }
        // });
        // accountContainer.appendChild(accountBtn);
        //
        // addBlock(accountContainer, itemHeight);

        // 1.5 Go to 2d page View 
        const pageModeContainer = createStandardItemContainer();

        const pageModeBg = document.createElement('a-rounded-plane');
        pageModeBg.setAttribute('height', itemHeight);
        pageModeBg.setAttribute('width', itemWidth);
        pageModeBg.setAttribute('radius', '0.01');
        pageModeBg.setAttribute('color', isLight ? '#1e1e1e' : '#fff');
        pageModeBg.setAttribute('opacity', '0.02');
        pageModeBg.setAttribute('position', `0 ${-itemHeight / 2} 0.002`);
        pageModeContainer.appendChild(pageModeBg);

        const pageModeLabel = document.createElement('a-troika-text');
        pageModeLabel.setAttribute('value', 'Current view: 3D');
        pageModeLabel.setAttribute('font-size', 0.02);
        pageModeLabel.setAttribute('color', txtColor);
        pageModeLabel.setAttribute('anchor', 'left');
        pageModeLabel.setAttribute('position', `${padding} 0 0.01`);
        pageModeContainer.appendChild(pageModeLabel);

        const pageModeBtn = document.createElement('a-entity');
        pageModeBtn.setAttribute("ui-button", {
            label: "Switch to 2D view",
            colorScheme: "tertiary",
            width: 0.22,
            height: 0.045,
            depth: 0.005,
            type: "rounded-box",
            radius: 0.01,
            preferredFontSize: 0.02,
        });
        pageModeBtn.setAttribute('position', `${itemWidth - 0.13} 0 0.01`);
        pageModeBtn.addEventListener('click', () => {
            if (window.gtag) {
                gtag('event', 'VR_TopNav_Settings_SwitchTo2D', {
                    event_callback: function () {
                        defaultBehavior()
                    }
                });
            } else {
                defaultBehavior()
            }

            function defaultBehavior() {
                const scene = document.querySelector('a-scene');
                if (scene && scene.exitVR) {
                    scene.exitVR();
                }
                window.location.href = './desktop.html';
            }
        });
        pageModeContainer.appendChild(pageModeBtn);

        addBlock(pageModeContainer, itemHeight);


        // 2. Mode (Complex)
        const modeBlock = this.createModeBlock(themeMode);
        addBlock(modeBlock, complexHeight);


        /* // 4. Skyscraper (Standard)
        const skContainer = createStandardItemContainer();
        this.populateToggle(skContainer, 'Skyscraper view', 'for Market Map chart', stockBarsTextures, 'stockBarsTextures', 0.18);
        addBlock(skContainer, itemHeight); */

        // 4.5 Timezone (Standard) - inverted: isETTimeZone=true means toggle is OFF (showing ET)
        const tzContainer = createStandardItemContainer();
        const isLocalTimezone = !this.data.isETTimeZone;
        this.populateTimezoneToggle(tzContainer, 'Local Timezone', 'Default: NYSE timezone, ET', isLocalTimezone, 'isETTimeZone');
        addBlock(tzContainer, itemHeight);

        // 4.6 Skip intro page (Standard)
        const skipIntroContainer = createStandardItemContainer();
        this.populateToggle(skipIntroContainer, 'Skip intro page', '', this.data.skipIntroPage, 'skipIntroPage', 0.18);
        addBlock(skipIntroContainer, itemHeight);


        // 5. Reposition (Complex)
        const repoBlock = this.createRepositionBlock();
        addBlock(repoBlock, complexHeight);

        // 7. View (Complex)
        const viewBlock = this.createViewBlock(view);
        addBlock(viewBlock, complexHeight);

        // 7.5 Display Quality
        const qualityBlock = this.createQualityBlock(quality);
        addBlock(qualityBlock, complexHeight);

        // 7.6 Invert mouse camera (per-device, stored in localStorage)
        const invertBlock = this.createInvertMouseCameraBlock();
        addBlock(invertBlock, complexHeight);

        const tutorialBlock = this.createTutorialReplayBlock();
        addBlock(tutorialBlock, itemHeight);

        // 8. Links (Standard - buttons only)
        const linksBlock = this.createLinksBlock();
        addBlock(linksBlock, itemHeight);

        // 9. Contact Us (Standard - buttons only)
        const contactBlock = this.createContactUsBlock();
        addBlock(contactBlock, itemHeight);
    },

    populateToggle: function (el, label, subLabel, isActive, key, subMargin) {
        const itemWidth = 0.56;
        const itemHeight = 0.06;
        const padding = 0.02;

        const isLight = this.data.themeMode === 'Light';
        const txtColor = isLight ? '#14141C' : '#FFFFFF';
        // For light mode, use a dark semi-transparent bg for items to stand out, or keep it subtle
        const itemBgColor = isLight ? '#000' : '#fff';
        const itemBgOpacity = isLight ? '0.05' : '0.1';

        const bg = document.createElement('a-rounded-plane');
        bg.setAttribute('height', itemHeight);
        bg.setAttribute('width', itemWidth);
        bg.setAttribute('radius', '0.01');
        bg.setAttribute('color', isLight ? '#1e1e1e' : '#fff');
        bg.setAttribute('opacity', '0.02');
        bg.setAttribute('position', `0 ${-itemHeight / 2} 0.002`);
        el.appendChild(bg);

        const interactivePlane = document.createElement('a-plane');
        interactivePlane.setAttribute('height', itemHeight);
        interactivePlane.setAttribute('width', itemWidth);
        interactivePlane.setAttribute('position', `${itemWidth / 2} 0 0.001`);
        interactivePlane.setAttribute('opacity', '0');
        interactivePlane.setAttribute('data-raycastable', '');
        interactivePlane.addEventListener('click', () => {
            const newValue = !this.data[key];
            this.el.setAttribute('main-settings', key, newValue);
            this.createSettingsList();
            if (key === 'stockBarsTextures') this.applySettings()
        });
        el.appendChild(interactivePlane);

        const mainLabel = document.createElement('a-troika-text');
        mainLabel.setAttribute('value', label);
        mainLabel.setAttribute('font-size', 0.02);
        mainLabel.setAttribute('color', txtColor);
        mainLabel.setAttribute('anchor', 'left');
        mainLabel.setAttribute('position', `${padding} 0 0.01`);
        el.appendChild(mainLabel);

        if (subLabel) {
            const sub = document.createElement('a-troika-text');
            sub.setAttribute('value', subLabel);
            sub.setAttribute('font-size', 0.015);
            sub.setAttribute('color', txtColor);
            sub.setAttribute('anchor', 'left');
            sub.setAttribute('position', `${subMargin} 0 0.01`);
            sub.setAttribute('fill-opacity', '0.5');
            el.appendChild(sub);
        }

        const toggleContainer = document.createElement('a-entity');
        toggleContainer.setAttribute('position', '0.52 0 0.01');

        const toggleBg = document.createElement('a-rounded-plane');
        toggleBg.setAttribute('position', '-0.03 -0.01 0');
        toggleBg.setAttribute('color', isLight ? '#1E1E1E' : '#fff');
        toggleBg.setAttribute('opacity', '0.05');
        toggleBg.setAttribute('height', 0.02);
        toggleBg.setAttribute('width', 0.06);
        toggleBg.setAttribute('radius', 0.006);
        toggleContainer.appendChild(toggleBg);

        const toggleButton = document.createElement('a-rounded-plane');
        toggleButton.setAttribute('position', isActive ? '0 -0.015 0.005' : '-0.03 -0.015 0.005');
        toggleButton.setAttribute('width', 0.03);
        toggleButton.setAttribute('height', 0.03);
        const activeColor = isLight ? '#3636E3' : '#FFF';
        const inactiveColor = isLight ? '#737373' : '#4F4F4F';
        toggleButton.setAttribute('color', isActive ? activeColor : inactiveColor);
        toggleButton.setAttribute('radius', 0.003);
        toggleContainer.appendChild(toggleButton);

        el.appendChild(toggleContainer);
    },

    populateTimezoneToggle: function (el, label, subLabel, isLocalTimezone, key) {
        const itemWidth = 0.56;
        const itemHeight = 0.06;
        const padding = 0.02;

        const isLight = this.data.themeMode === 'Light';
        const txtColor = isLight ? '#14141C' : '#FFFFFF';
        const itemBgColor = isLight ? '#000' : '#fff';
        const itemBgOpacity = isLight ? '0.05' : '0.1';

        const bg = document.createElement('a-rounded-plane');
        bg.setAttribute('height', itemHeight);
        bg.setAttribute('width', itemWidth);
        bg.setAttribute('radius', '0.01');
        bg.setAttribute('color', isLight ? '#1e1e1e' : '#fff');
        bg.setAttribute('opacity', '0.02');
        bg.setAttribute('position', `0 ${-itemHeight / 2} 0.002`);
        el.appendChild(bg);

        const interactivePlane = document.createElement('a-plane');
        interactivePlane.setAttribute('height', itemHeight);
        interactivePlane.setAttribute('width', itemWidth);
        interactivePlane.setAttribute('position', `${itemWidth / 2} 0 0.001`);
        interactivePlane.setAttribute('opacity', '0');
        interactivePlane.setAttribute('data-raycastable', '');
        interactivePlane.addEventListener('click', () => {
            // Invert: toggle ON = local timezone (isETTimeZone = false)
            const newETValue = !this.data[key];
            this.el.setAttribute('main-settings', key, newETValue);

            // Dispatch global event for other components
            try {
                const event = new CustomEvent('timezone-changed', {
                    detail: { isETTimeZone: newETValue }
                });
                document.dispatchEvent(event);
                console.log('[Main Settings] Dispatched timezone-changed event, isETTimeZone:', newETValue);
            } catch (e) {
                console.warn('[Main Settings] Failed to dispatch timezone-changed event', e);
            }

            this.createSettingsList();

            if (window.gtag) gtag('event', `VR_TopNav_Settings_TimeZone${newETValue ? 'ET' : 'Local'}`);
        });
        el.appendChild(interactivePlane);

        const mainLabel = document.createElement('a-troika-text');
        mainLabel.setAttribute('value', label);
        mainLabel.setAttribute('font-size', 0.02);
        mainLabel.setAttribute('color', txtColor);
        mainLabel.setAttribute('anchor', 'left');
        mainLabel.setAttribute('position', `${padding} 0 0.01`);
        el.appendChild(mainLabel);

        // Sublabel showing default timezone info
        const sub = document.createElement('a-troika-text');
        sub.setAttribute('value', subLabel);
        sub.setAttribute('font-size', 0.012);
        sub.setAttribute('color', txtColor);
        sub.setAttribute('anchor', 'left');
        sub.setAttribute('position', `0.18 0 0.01`);
        sub.setAttribute('fill-opacity', '0.5');
        el.appendChild(sub);

        const toggleContainer = document.createElement('a-entity');
        toggleContainer.setAttribute('position', '0.52 0 0.01');

        const toggleBg = document.createElement('a-rounded-plane');
        toggleBg.setAttribute('position', '-0.03 -0.01 0');
        toggleBg.setAttribute('color', isLight ? '#1E1E1E' : '#fff');
        toggleBg.setAttribute('opacity', '0.05');
        toggleBg.setAttribute('height', 0.02);
        toggleBg.setAttribute('width', 0.06);
        toggleBg.setAttribute('radius', 0.006);
        toggleContainer.appendChild(toggleBg);

        // Toggle visual: ON when isLocalTimezone is true
        const toggleButton = document.createElement('a-rounded-plane');
        toggleButton.setAttribute('position', isLocalTimezone ? '0 -0.015 0.005' : '-0.03 -0.015 0.005');
        toggleButton.setAttribute('width', 0.03);
        toggleButton.setAttribute('height', 0.03);
        const activeColor = isLight ? '#3636E3' : '#FFF';
        const inactiveColor = isLight ? '#737373' : '#4F4F4F';
        toggleButton.setAttribute('color', isLocalTimezone ? activeColor : inactiveColor);
        toggleButton.setAttribute('radius', 0.003);
        toggleContainer.appendChild(toggleButton);

        el.appendChild(toggleContainer);
    },

    createModeBlock: function (currentMode) {
        const itemElement = document.createElement('a-entity');
        const itemWidth = 0.56;
        const rowHeight = 0.06;
        const padding = 0.02;

        const isLight = this.data.themeMode === 'Light';
        const txtColor = isLight ? '#14141C' : '#FFFFFF';
        const itemBgColor = isLight ? '#000' : '#fff';
        const itemBgOpacity = isLight ? '0.05' : '0.1';

        // Selection Color Logic:
        // Light Theme: Blue (#3636E3)
        // Dark Theme: White (#FFFFFF)
        const selectColor = isLight ? '#3636E3' : '#FFFFFF';

        const mainLabel = document.createElement('a-troika-text');
        mainLabel.setAttribute('value', 'Mode');
        mainLabel.setAttribute('font-size', 0.02);
        mainLabel.setAttribute('color', txtColor);
        mainLabel.setAttribute('anchor', 'left');
        mainLabel.setAttribute('position', `${padding} 0 0.01`);
        itemElement.appendChild(mainLabel);

        const bg = document.createElement('a-rounded-plane');
        bg.setAttribute('height', rowHeight);
        bg.setAttribute('width', itemWidth);
        bg.setAttribute('radius', '0.01');
        bg.setAttribute('color', isLight ? '#1e1e1e' : '#fff');
        bg.setAttribute('opacity', '0.02');
        bg.setAttribute('position', `0 ${-rowHeight - 0.05} 0.002`);
        itemElement.appendChild(bg);

        const selectPlane = document.createElement('a-rounded-plane');
        selectPlane.setAttribute('height', rowHeight);
        selectPlane.setAttribute('width', itemWidth / 2);
        selectPlane.setAttribute('radius', '0.01');
        selectPlane.setAttribute('color', selectColor);
        selectPlane.setAttribute('position', `${currentMode === 'Dark' ? 0 : itemWidth / 2} ${-rowHeight - 0.05} 0.003`);
        itemElement.appendChild(selectPlane);

        // Text Color Logic:
        let darkTextColor, lightTextColor;

        if (isLight) {
            darkTextColor = currentMode === 'Dark' ? '#FFFFFF' : '#14141C';
            lightTextColor = currentMode === 'Light' ? '#FFFFFF' : '#14141C';
        } else {
            darkTextColor = currentMode === 'Dark' ? '#14141C' : '#FFFFFF';
            lightTextColor = currentMode === 'Light' ? '#14141C' : '#FFFFFF';
        }

        const darkText = document.createElement('a-troika-text');
        darkText.setAttribute('value', 'Dark');
        darkText.setAttribute('color', darkTextColor);
        darkText.setAttribute('font-size', 0.02);
        darkText.setAttribute('anchor', 'center');
        darkText.setAttribute('position', `${itemWidth / 4} ${-rowHeight / 2 - 0.05} 0.004`);
        itemElement.appendChild(darkText);

        const lightText = document.createElement('a-troika-text');
        lightText.setAttribute('value', 'Light');
        lightText.setAttribute('color', lightTextColor);
        lightText.setAttribute('font-size', 0.02);
        lightText.setAttribute('anchor', 'center');
        lightText.setAttribute('position', `${itemWidth * 0.75} ${-rowHeight / 2 - 0.05} 0.004`);
        itemElement.appendChild(lightText);

        const darkBtn = document.createElement('a-plane');
        darkBtn.setAttribute('height', rowHeight);
        darkBtn.setAttribute('width', itemWidth / 2);
        darkBtn.setAttribute('opacity', '0');
        darkBtn.setAttribute('data-raycastable', '');
        darkBtn.setAttribute('position', `${itemWidth / 4} ${-rowHeight / 2 - 0.05} 0.005`);
        darkBtn.addEventListener('click', () => {
            this.el.setAttribute('main-settings', 'themeMode', 'Dark');
            this.createSettingsList();
            this.applySettings();

            if (window.gtag) gtag('event', `VR_TopNav_Settings_DarkMode`);
        });
        itemElement.appendChild(darkBtn);

        const lightBtn = document.createElement('a-plane');
        lightBtn.setAttribute('height', rowHeight);
        lightBtn.setAttribute('width', itemWidth / 2);
        lightBtn.setAttribute('opacity', '0');
        lightBtn.setAttribute('data-raycastable', '');
        lightBtn.setAttribute('position', `${itemWidth * 0.75} ${-rowHeight / 2 - 0.05} 0.005`);
        lightBtn.addEventListener('click', () => {
            this.el.setAttribute('main-settings', 'themeMode', 'Light');
            this.createSettingsList();
            this.applySettings();

            if (window.gtag) gtag('event', `VR_TopNav_Settings_LightMode`);
        });
        itemElement.appendChild(lightBtn);

        return itemElement;
    },

    createRepositionBlock: function () {
        const itemElement = document.createElement('a-entity');
        const itemWidth = 0.56;
        const rowHeight = 0.06;
        const padding = 0.02;

        const isLight = this.data.themeMode === 'Light';
        const txtColor = isLight ? '#14141C' : '#FFFFFF';

        const mainLabel = document.createElement('a-troika-text');
        mainLabel.setAttribute('value', 'Reposition Panels');
        mainLabel.setAttribute('font-size', 0.02);
        mainLabel.setAttribute('color', txtColor);
        mainLabel.setAttribute('anchor', 'left');
        mainLabel.setAttribute('position', `${padding} 0 0.01`);
        itemElement.appendChild(mainLabel);

        const btn1 = document.createElement("a-entity");
        btn1.setAttribute("ui-button", {
            label: "Reposition",
            colorScheme: "accent",
            width: 0.27,
            height: rowHeight,
            depth: 0.01,
            type: "rounded-box",
            radius: 0.01,
            preferredFontSize: 0.02,
        });
        btn1.setAttribute('position', `${itemWidth * 0.25} ${-rowHeight / 2 - 0.05} 0.01`);
        btn1.addEventListener('click', () => {
            this.isRepositioning = true;
            this.toggleRepositionMode();

            const repositionPopup = document.querySelector('#reposition-popup');
            const repositionPopupComponent = repositionPopup && repositionPopup.components
                ? repositionPopup.components['reposition-popup']
                : null;

            if (window.PopupManager) {
                this._switchingToRepoPopup = true;
                window.PopupManager.open('reposition-popup');
                this._switchingToRepoPopup = false;
            } else if (repositionPopup && repositionPopupComponent) {
                repositionPopup.setAttribute('visible', true);
                repositionPopupComponent.open();
            }

            if (window.gtag) gtag('event', `VR_TopNav_Settings_Reposition`);
        });
        itemElement.appendChild(btn1);

        const btn2 = document.createElement("a-entity");
        btn2.setAttribute("ui-button", {
            label: "Reset",
            colorScheme: "primary",
            width: 0.27,
            height: rowHeight,
            depth: 0.01,
            type: "rounded-box",
            radius: 0.01,
            preferredFontSize: 0.02,
        });
        btn2.setAttribute('position', `${itemWidth * 0.75} ${-rowHeight / 2 - 0.05} 0.01`);
        btn2.addEventListener('click', () => this.handleReset());
        itemElement.appendChild(btn2);

        return itemElement;
    },

    createViewBlock: function (currentView) {
        const itemElement = document.createElement('a-entity');
        const itemWidth = 0.56;
        const rowHeight = 0.06;
        const padding = 0.02;

        const isLight = this.data.themeMode === 'Light';
        const txtColor = isLight ? '#14141C' : '#FFFFFF';
        const itemBgColor = isLight ? '#000' : '#fff';
        const itemBgOpacity = isLight ? '0.05' : '0.1';

        // Selection Color Logic:
        // Light Theme: Blue (#3636E3)
        // Dark Theme: White (#FFFFFF)
        const selectColor = isLight ? '#3636E3' : '#FFFFFF';

        const mainLabel = document.createElement('a-troika-text');
        mainLabel.setAttribute('value', 'View');
        mainLabel.setAttribute('font-size', 0.02);
        mainLabel.setAttribute('color', txtColor);
        mainLabel.setAttribute('anchor', 'left');
        mainLabel.setAttribute('position', `${padding} 0 0.01`);
        itemElement.appendChild(mainLabel);

        const bg = document.createElement('a-rounded-plane');
        bg.setAttribute('height', rowHeight);
        bg.setAttribute('width', itemWidth);
        bg.setAttribute('radius', '0.01');
        bg.setAttribute('color', isLight ? '#1e1e1e' : '#fff');
        bg.setAttribute('opacity', '0.02');
        bg.setAttribute('position', `0 ${-rowHeight - 0.05} 0.002`);
        itemElement.appendChild(bg);

        const selectPlane = document.createElement('a-rounded-plane');
        selectPlane.setAttribute('height', rowHeight);
        selectPlane.setAttribute('width', itemWidth / 2);
        selectPlane.setAttribute('radius', '0.01');
        selectPlane.setAttribute('color', selectColor);
        selectPlane.setAttribute('position', `${currentView === 'VR' ? 0 : itemWidth / 2} ${-rowHeight - 0.05} 0.003`);
        itemElement.appendChild(selectPlane);

        // Text Color Logic:
        let vrColor, arColor;

        if (isLight) {
            // LIGHT THEME (Background: Light, Selection: Blue)
            // VR (Selected) -> White Text on Blue Selection
            // AR (Unselected) -> Dark Text on Light Bg
            vrColor = currentView === 'VR' ? '#FFFFFF' : '#14141C';
            arColor = currentView === 'AR' ? '#FFFFFF' : '#14141C';
        } else {
            // DARK THEME (Background: Dark, Selection: White)
            // VR (Selected) -> Black Text (#14141C) on White Selection
            // AR (Unselected) -> White Text (#FFFFFF) on Dark Bg
            vrColor = currentView === 'VR' ? '#14141C' : '#FFFFFF';
            arColor = currentView === 'AR' ? '#14141C' : '#FFFFFF';
        }

        const vrText = document.createElement('a-troika-text');
        vrText.setAttribute('value', 'VR');
        vrText.setAttribute('color', vrColor);
        vrText.setAttribute('font-size', 0.02);
        vrText.setAttribute('anchor', 'center');
        vrText.setAttribute('position', `${itemWidth / 4} ${-rowHeight / 2 - 0.05} 0.004`);
        itemElement.appendChild(vrText);

        const arText = document.createElement('a-troika-text');
        arText.setAttribute('value', 'AR');
        arText.setAttribute('color', arColor);
        arText.setAttribute('font-size', 0.02);
        arText.setAttribute('anchor', 'center');
        arText.setAttribute('position', `${itemWidth * 0.75} ${-rowHeight / 2 - 0.05} 0.004`);
        itemElement.appendChild(arText);

        const vrBtn = document.createElement('a-plane');
        vrBtn.setAttribute('height', rowHeight);
        vrBtn.setAttribute('width', itemWidth / 2);
        vrBtn.setAttribute('opacity', '0');
        vrBtn.setAttribute('data-raycastable', '');
        vrBtn.setAttribute('position', `${itemWidth / 4} ${-rowHeight / 2 - 0.05} 0.005`);
        vrBtn.addEventListener('click', () => {
            this.el.setAttribute('main-settings', 'view', 'VR');
            this.createSettingsList();
            this.applySettings();

            if (window.gtag) gtag('event', `VR_TopNav_Settings_VRViewSelected`);
        });
        itemElement.appendChild(vrBtn);

        const arBtn = document.createElement('a-plane');
        arBtn.setAttribute('height', rowHeight);
        arBtn.setAttribute('width', itemWidth / 2);
        arBtn.setAttribute('opacity', '0');
        arBtn.setAttribute('data-raycastable', '');
        arBtn.setAttribute('position', `${itemWidth * 0.75} ${-rowHeight / 2 - 0.05} 0.005`);
        arBtn.addEventListener('click', () => {
            this.el.setAttribute('main-settings', 'view', 'AR');
            this.createSettingsList();
            this.applySettings();

            if (window.gtag) gtag('event', `VR_TopNav_Settings_ARViewSelected`);
        });
        itemElement.appendChild(arBtn);

        return itemElement;
    },

    createQualityBlock: function (currentQualityFromProps) {
        // if user not select
        const isMobile = /(iPhone|iPad|iPod|Android|Mobi|Tablet)/i.test(navigator.userAgent);
        let currentQuality = currentQualityFromProps ? currentQualityFromProps : (isMobile ? 'performance' : 'quality');
        
        const itemElement = document.createElement('a-entity');
        const itemWidth = 0.56;
        const rowHeight = 0.06;
        const padding = 0.02;

        const isLight = this.data.themeMode === 'Light';
        const txtColor = isLight ? '#14141C' : '#FFFFFF';

        // Selection Color Logic:
        // Light Theme: Blue (#3636E3)
        // Dark Theme: White (#FFFFFF)
        const selectColor = isLight ? '#3636E3' : '#FFFFFF';

        const mainLabel = document.createElement('a-troika-text');
        mainLabel.setAttribute('value', 'Display quality');
        mainLabel.setAttribute('font-size', 0.02);
        mainLabel.setAttribute('color', txtColor);
        mainLabel.setAttribute('anchor', 'left');
        mainLabel.setAttribute('position', `${padding} 0 0.01`);
        itemElement.appendChild(mainLabel);

        const bg = document.createElement('a-rounded-plane');
        bg.setAttribute('height', rowHeight);
        bg.setAttribute('width', itemWidth);
        bg.setAttribute('radius', '0.01');
        bg.setAttribute('color', isLight ? '#1e1e1e' : '#fff');
        bg.setAttribute('opacity', '0.02');
        bg.setAttribute('position', `0 ${-rowHeight - 0.05} 0.002`);
        itemElement.appendChild(bg);

        const selectPlane = document.createElement('a-rounded-plane');
        selectPlane.setAttribute('height', rowHeight);
        selectPlane.setAttribute('width', itemWidth / 2);
        selectPlane.setAttribute('radius', '0.01');
        selectPlane.setAttribute('color', selectColor);
        selectPlane.setAttribute('position', `${currentQuality === 'quality' ? 0 : itemWidth / 2} ${-rowHeight - 0.05} 0.003`);
        itemElement.appendChild(selectPlane);

        // Text Color Logic:
        let qualityColor, performanceColor;

        if (isLight) {
            // LIGHT THEME (Background: Light, Selection: Blue)
            // VR (Selected) -> White Text on Blue Selection
            // AR (Unselected) -> Dark Text on Light Bg
            qualityColor = currentQuality === 'quality' ? '#FFFFFF' : '#14141C';
            performanceColor = currentQuality === 'performance' ? '#FFFFFF' : '#14141C';
        } else {
            // DARK THEME (Background: Dark, Selection: White)
            // VR (Selected) -> Black Text (#14141C) on White Selection
            // AR (Unselected) -> White Text (#FFFFFF) on Dark Bg
            qualityColor = currentQuality === 'quality' ? '#14141C' : '#FFFFFF';
            performanceColor = currentQuality === 'performance' ? '#14141C' : '#FFFFFF';
        }

        const qualityText = document.createElement('a-troika-text');
        qualityText.setAttribute('value', 'Higher quality');
        qualityText.setAttribute('color', qualityColor);
        qualityText.setAttribute('font-size', 0.02);
        qualityText.setAttribute('anchor', 'center');
        qualityText.setAttribute('position', `${itemWidth / 4} ${-rowHeight / 2 - 0.05} 0.004`);
        itemElement.appendChild(qualityText);

        const performanceText = document.createElement('a-troika-text');
        performanceText.setAttribute('value', 'Faster performance');
        performanceText.setAttribute('color', performanceColor);
        performanceText.setAttribute('font-size', 0.02);
        performanceText.setAttribute('anchor', 'center');
        performanceText.setAttribute('position', `${itemWidth * 0.75} ${-rowHeight / 2 - 0.05} 0.004`);
        itemElement.appendChild(performanceText);

        const qualityBtn = document.createElement('a-plane');
        qualityBtn.setAttribute('height', rowHeight);
        qualityBtn.setAttribute('width', itemWidth / 2);
        qualityBtn.setAttribute('opacity', '0');
        qualityBtn.setAttribute('data-raycastable', '');
        qualityBtn.setAttribute('position', `${itemWidth / 4} ${-rowHeight / 2 - 0.05} 0.005`);
        qualityBtn.addEventListener('click', () => {
            this.el.setAttribute('main-settings', 'quality', 'quality');
            // this.createSettingsList();
            this.applySettings();

            if (window.gtag) {
                gtag('event', 'VR_TopNav_Settings_HigherQualitySelected', {event_callback:  defaultBehavior});
            } else {
                defaultBehavior()
            }
        });
        itemElement.appendChild(qualityBtn);

        const performanceBtn = document.createElement('a-plane');
        performanceBtn.setAttribute('height', rowHeight);
        performanceBtn.setAttribute('width', itemWidth / 2);
        performanceBtn.setAttribute('opacity', '0');
        performanceBtn.setAttribute('data-raycastable', '');
        performanceBtn.setAttribute('position', `${itemWidth * 0.75} ${-rowHeight / 2 - 0.05} 0.005`);
        performanceBtn.addEventListener('click', () => {
            this.el.setAttribute('main-settings', 'quality', 'performance');
            // this.createSettingsList();
            this.applySettings();
            
            if (window.gtag) {
                gtag('event', 'VR_TopNav_Settings_FastPerformanceSelected', {event_callback:  defaultBehavior});
            } else {
                defaultBehavior()
            }
        });        
        itemElement.appendChild(performanceBtn);

        function defaultBehavior() {
            const scene = document.querySelector('a-scene');
            if (scene && scene.exitVR) {
                scene.exitVR();
            }
            window.location.reload();
        }

        return itemElement;
    },

    createInvertMouseCameraBlock: function () {
        const itemElement = document.createElement('a-entity');
        const itemWidth = 0.56;
        const rowHeight = 0.06;
        const padding = 0.02;

        const isLight = this.data.themeMode === 'Light';
        const txtColor = isLight ? '#14141C' : '#FFFFFF';
        const selectColor = isLight ? '#3636E3' : '#FFFFFF';

        const invertState = this._loadInvertMouseCamera();
        const isInvertX = invertState.x;
        const isInvertY = invertState.y;
        const isDefault = !isInvertX && !isInvertY;
        const isFullInvert = isInvertX && isInvertY;

        const currentMode = (isInvertX || isInvertY) ? 'invert' : 'default';

        const mainLabel = document.createElement('a-troika-text');
        mainLabel.setAttribute('value', 'Invert mouse camera');
        mainLabel.setAttribute('font-size', 0.02);
        mainLabel.setAttribute('color', txtColor);
        mainLabel.setAttribute('anchor', 'left');
        mainLabel.setAttribute('position', `${padding} 0 0.01`);
        itemElement.appendChild(mainLabel);

        const bg = document.createElement('a-rounded-plane');
        bg.setAttribute('height', rowHeight);
        bg.setAttribute('width', itemWidth);
        bg.setAttribute('radius', '0.01');
        bg.setAttribute('color', isLight ? '#1e1e1e' : '#fff');
        bg.setAttribute('opacity', '0.02');
        bg.setAttribute('position', `0 ${-rowHeight - 0.05} 0.002`);
        itemElement.appendChild(bg);

        const selectPlane = document.createElement('a-rounded-plane');
        selectPlane.setAttribute('height', rowHeight);
        selectPlane.setAttribute('width', itemWidth / 2);
        selectPlane.setAttribute('radius', '0.01');
        selectPlane.setAttribute('color', selectColor);
        selectPlane.setAttribute('position', `${currentMode === 'default' ? 0 : itemWidth / 2} ${-rowHeight - 0.05} 0.003`);
        itemElement.appendChild(selectPlane);

        let defaultColor, invertColor;
        if (isLight) {
            defaultColor = currentMode === 'default' ? '#FFFFFF' : '#14141C';
            invertColor  = currentMode === 'invert'  ? '#FFFFFF' : '#14141C';
        } else {
            defaultColor = currentMode === 'default' ? '#14141C' : '#FFFFFF';
            invertColor  = currentMode === 'invert'  ? '#14141C' : '#FFFFFF';
        }

        const defaultText = document.createElement('a-troika-text');
        defaultText.setAttribute('value', 'Default');
        defaultText.setAttribute('color', defaultColor);
        defaultText.setAttribute('font-size', 0.02);
        defaultText.setAttribute('anchor', 'center');
        defaultText.setAttribute('position', `${itemWidth / 4} ${-rowHeight / 2 - 0.05} 0.004`);
        itemElement.appendChild(defaultText);

        const invertText = document.createElement('a-troika-text');
        invertText.setAttribute('value', 'Invert');
        invertText.setAttribute('color', invertColor);
        invertText.setAttribute('font-size', 0.02);
        invertText.setAttribute('anchor', 'center');
        invertText.setAttribute('position', `${itemWidth * 0.75} ${-rowHeight / 2 - 0.05} 0.004`);
        itemElement.appendChild(invertText);

        const defaultBtn = document.createElement('a-plane');
        defaultBtn.setAttribute('height', rowHeight);
        defaultBtn.setAttribute('width', itemWidth / 2);
        defaultBtn.setAttribute('opacity', '0');
        defaultBtn.setAttribute('data-raycastable', '');
        defaultBtn.setAttribute('position', `${itemWidth / 4} ${-rowHeight / 2 - 0.05} 0.005`);
        defaultBtn.addEventListener('click', () => {
            this._saveInvertMouseCamera({ x: false, y: false });
            // Notify camera-rig-handler
            document.dispatchEvent(new CustomEvent('invert-mouse-camera-changed', { detail: { x: false, y: false } }));
            this.createSettingsList();
            if (window.gtag) gtag('event', 'VR_TopNav_Settings_InvertMouseCamera_Default');
        });
        itemElement.appendChild(defaultBtn);

        const invertBtn = document.createElement('a-plane');
        invertBtn.setAttribute('height', rowHeight);
        invertBtn.setAttribute('width', itemWidth / 2);
        invertBtn.setAttribute('opacity', '0');
        invertBtn.setAttribute('data-raycastable', '');
        invertBtn.setAttribute('position', `${itemWidth * 0.75} ${-rowHeight / 2 - 0.05} 0.005`);
        invertBtn.addEventListener('click', () => {
            this._saveInvertMouseCamera({ x: true, y: true });
            document.dispatchEvent(new CustomEvent('invert-mouse-camera-changed', { detail: { x: true, y: true } }));
            this.createSettingsList();
            if (window.gtag) gtag('event', 'VR_TopNav_Settings_InvertMouseCamera_Invert');
        });
        itemElement.appendChild(invertBtn);

        return itemElement;
    },

    createTutorialReplayBlock: function () {
        const itemElement = document.createElement('a-entity');
        const itemWidth = 0.56;
        const itemHeight = 0.06;
        const padding = 0.02;

        const isLight = this.data.themeMode === 'Light';
        const txtColor = isLight ? '#14141C' : '#FFFFFF';

        const bg = document.createElement('a-rounded-plane');
        bg.setAttribute('height', itemHeight);
        bg.setAttribute('width', itemWidth);
        bg.setAttribute('radius', '0.01');
        bg.setAttribute('color', isLight ? '#1e1e1e' : '#fff');
        bg.setAttribute('opacity', '0.02');
        bg.setAttribute('position', `0 ${-itemHeight / 2} 0.002`);
        itemElement.appendChild(bg);

        const mainLabel = document.createElement('a-troika-text');
        mainLabel.setAttribute('value', 'Tutorial');
        mainLabel.setAttribute('font-size', 0.02);
        mainLabel.setAttribute('color', txtColor);
        mainLabel.setAttribute('anchor', 'left');
        mainLabel.setAttribute('position', `${padding} 0.008 0.01`);
        itemElement.appendChild(mainLabel);

        const subLabel = document.createElement('a-troika-text');
        subLabel.setAttribute('value', 'Replay the onboarding tips.');
        subLabel.setAttribute('font-size', 0.015);
        subLabel.setAttribute('color', txtColor);
        subLabel.setAttribute('anchor', 'left');
        subLabel.setAttribute('position', `${padding} -0.012 0.01`);
        subLabel.setAttribute('fill-opacity', '0.5');
        itemElement.appendChild(subLabel);

        const replayBtn = document.createElement('a-entity');
        replayBtn.setAttribute('ui-button', {
            label: 'Replay tutorial',
            colorScheme: 'primary',
            width: 0.22,
            height: 0.045,
            depth: 0.005,
            type: 'rounded-box',
            radius: 0.01,
            preferredFontSize: 0.018,
        });
        replayBtn.setAttribute('position', `${itemWidth - 0.13} 0 0.01`);
        replayBtn.setAttribute('data-raycastable', '');
        replayBtn.addEventListener('click', () => {
            if (window.PopupManager) {
                window.PopupManager.close('main-settings-popup');
            } else {
                this.close();
            }
            if (window.StockStormTutorial && typeof window.StockStormTutorial.open === 'function') {
                window.StockStormTutorial.open({ force: true, step: 0 });
            }
            if (window.gtag) {
                gtag('event', 'VR_TopNav_Settings_ReplayTutorial');
            }
        });
        itemElement.appendChild(replayBtn);

        return itemElement;
    },

    createLinksBlock: function () {
        const itemElement = document.createElement('a-entity');
        const itemWidth = 0.56;
        const rowHeight = 0.06;

        const labels = ['Privacy', 'Terms', 'About'];
        const urls = [
            'privacy.html',
            'terms.html',
            'index.html?source=vis-platform'
        ];

        labels.forEach((label, i) => {
            const btn = document.createElement("a-entity");
            btn.setAttribute("ui-button", {
                label: label,
                colorScheme: "tertiary",
                width: 0.16,
                height: rowHeight,
                depth: 0.01,
                type: "rounded-box",
                radius: 0.01,
                preferredFontSize: 0.02,
            });

            // Calculate x position to center 3 buttons
            const x = (itemWidth / 2) + (i - 1) * 0.18;

            // Center vertically in the row
            btn.setAttribute('position', `${x} ${-rowHeight / 2} 0.01`);

            btn.addEventListener('click', () => {
                if (window.gtag) {
                    let eventName = 'VR_TopNav_Settings_';
                    const linkNames = ['PrivacyClick', 'TermsOfUseClick', 'AboutUsClick'];
                    gtag('event', eventName + linkNames[i], {
                        event_callback: function () {
                            defaultBehavior()
                        }
                    });
                } else {
                    defaultBehavior()
                }

                function defaultBehavior() {
                    const scene = document.querySelector('a-scene');
                    if (scene && scene.exitVR) {
                        scene.exitVR();
                    }
                    window.open(urls[i], '_blank');
                }
            });
            itemElement.appendChild(btn);
        });

        return itemElement;
    },
    createContactUsBlock: function () {
        const itemWidth = 0.56;
        const rowHeight = 0.06;
        const itemElement = document.createElement('a-entity');

        const btn = document.createElement("a-entity");
        btn.setAttribute("ui-button", {
            label: 'Contact us via support@stockstorm.ai',
            colorScheme: "tertiary",
            width: 0.52,
            height: rowHeight,
            depth: 0.01,
            type: "rounded-box",
            radius: 0.01,
            preferredFontSize: 0.02,
        });
        btn.setAttribute('position', `${itemWidth / 2} ${-rowHeight / 2} 0.01`);

        btn.addEventListener('click', () => {
            if (window.gtag) {
                gtag('event', 'VR_TopNav_Settings_ContactClick', {
                    event_callback: function () {
                        window.location.href = 'mailto:support@StockStorm.ai';
                    }
                });
            } else {
                window.location.href = 'mailto:support@StockStorm.ai';
            }
        })

        itemElement.appendChild(btn);
        return itemElement
    },

    applySettings: function () {
        // 0. Update popup background
        if (this.data.themeMode === 'Light') {
            if (this.popupBgDark) this.popupBgDark.setAttribute('visible', false);
            if (this.popupBgLight) this.popupBgLight.setAttribute('visible', true);
            // Re-create header if visible to update text colors
            if (this.el.getAttribute('visible')) {
                this.createHeader();
            }
        } else {
            if (this.popupBgDark) this.popupBgDark.setAttribute('visible', true);
            if (this.popupBgLight) this.popupBgLight.setAttribute('visible', false);
            if (this.el.getAttribute('visible')) {
                this.createHeader();
            }
        }

        const skyboxSphere = document.querySelector('#skybox-sphere');
        if (skyboxSphere) {
            skyboxSphere.setAttribute('material', 'src', this.data.themeMode === 'Light' ? '#skybox-light' : '#skybox-dark');
        }
        const logoBlack = document.querySelector('#logo-black');
        const logoWhite = document.querySelector('#logo-white');
        if (logoBlack && logoWhite) {
            const isLight = this.data.themeMode === 'Light';
            logoBlack.setAttribute('visible', isLight);
            logoWhite.setAttribute('visible', !isLight);
        }
        if (this.data.view === 'AR') {
            this.handleClickARButton();
        } else {
            this.handleClickVRButton();
        }


        if (this.bgPanels) {
            this.bgPanels.setAttribute('visible', this.data.bgPanelsShow)
            this.bgPanels.dataset.shouldBeVisible = this.data.bgPanelsShow;
        }


        this._saveSettings();
    },

    _updateCentralHandlePosition: function () {
        if (!this.moveCentralPanelArea) return;

        const chartTypeEl = document.querySelector('[chart-type-control]');
        const action = chartTypeEl?.getAttribute('chart-type-control')?.selectedPrimeAction;
        const mmapMode = (window.MarketMapModeSwitching && window.MarketMapModeSwitching.getCurrentMode)
            ? window.MarketMapModeSwitching.getCurrentMode()
            : (typeof getCacheItem === 'function' ? getCacheItem('mmap_view_mode') : null) || '2d';

        if (action === 'mmap' && mmapMode === '2d') {
            const MMAP_Y_CENTER = 0.11, MMAP_Y_SIDE = 0.30;
            const DELTA_Y = 0.48, DELTA_Z = 0.10;

            const _memEl = document.querySelector('[main-elements-moving]');
            const _memComp = _memEl?.components?.['main-elements-moving'];
            const _isCenterSlot = !_memComp || _memComp.data.currentStep === 0;

            if (_isCenterSlot) {
                const rot = this.centralPanel?.getAttribute('rotation');
                const panelRotY = typeof rot === 'object' ? (rot.y || 0)
                    : (parseFloat(String(rot || '0 0 0').split(' ')[1]) || 0);
                this.moveCentralPanelArea.setAttribute('position',
                    `0 ${MMAP_Y_CENTER + DELTA_Y} ${DELTA_Z}`);
                this.moveCentralPanelArea.setAttribute('rotation', `0 ${-panelRotY} 0`);
            } else {
                const pos = this.centralPanel?.getAttribute('position');
                const panelX = typeof pos === 'object' ? (pos.x || 0)
                    : (parseFloat(String(pos || '0 0 0').split(' ')[0]) || 0);
                const isRightSlot = panelX > 0;
                const handleX = isRightSlot ? 0.08 : 0.04;
                const handleZ = isRightSlot ? DELTA_Z : DELTA_Z + 0.04;
                this.moveCentralPanelArea.setAttribute('position',
                    `${handleX} ${MMAP_Y_SIDE + DELTA_Y} ${handleZ}`);
                this.moveCentralPanelArea.setAttribute('rotation', '0 0 0');
            }
            return;
        }

        if (this.centralPanel) {
            const rot = this.centralPanel.getAttribute('rotation');
            const panelRotY = typeof rot === 'object' ? (rot.y || 0) : (parseFloat(String(rot).split(' ')[1]) || 0);
            this.moveCentralPanelArea.setAttribute('rotation', `0 ${-panelRotY} 0`);
        }
        this.moveCentralPanelArea.setAttribute('position', '0 0.49 0.1');
    },

    toggleRepositionMode: function () {
        this.handleClickManualButton();
    },

    handleClickManualButton: function () {
        this.searchPanel = document.querySelector('#search-center-panel');
        this.moveSearchPanelArea = document.querySelector('#move-search-panel-area');
        this.watchlistTable = document.querySelector('#watchlist-table');
        this.moveWatchlistTableArea = document.querySelector('#move-watchlist-table-area');

        if (this.moveRightPanelArea) {
            this.moveRightPanelArea.setAttribute('visible', 'true');
            this.moveRightPanelArea.setAttribute('data-raycastable', 'true');
            this.switchBlockingElement(this.rightPanel, false)
        }
        if (this.moveLeftPanelArea) {
            this.moveLeftPanelArea.setAttribute('visible', 'true');
            this.moveLeftPanelArea.setAttribute('data-raycastable', 'true');
            this.switchBlockingElement(this.leftPanel, false)
        }
        if (this.moveDockArea) {
            this.moveDockArea.setAttribute('visible', 'true');
            this.moveDockArea.setAttribute('data-raycastable', 'true');
            this.switchBlockingElement(this.dock, false)
        }
        if (this.moveCentralPanelArea) {
            const isWatchlistVisible = this.watchlistTable && this.watchlistTable.getAttribute('visible');

            if (!isWatchlistVisible) {
                this._updateCentralHandlePosition();
                this.moveCentralPanelArea.setAttribute('visible', 'true');
                this.moveCentralPanelArea.setAttribute('data-raycastable', 'true');
                this.switchBlockingElement(this.centralPanel, false)
            } else {
                this.moveCentralPanelArea.setAttribute('visible', 'false');
                this.moveCentralPanelArea.removeAttribute('data-raycastable');
            }
        }
        if (this.moveTopMenuArea) {
            this.moveTopMenuArea.setAttribute('visible', 'true');
            this.moveTopMenuArea.setAttribute('data-raycastable', 'true');
        }
        if (this.moveChartTypeArea) {
            this.moveChartTypeArea.setAttribute('visible', 'true');
            this.moveChartTypeArea.setAttribute('data-raycastable', 'true');
        }

        if (this.moveSearchPanelArea && this.searchPanel && this.searchPanel.object3D.visible) {
            this.moveSearchPanelArea.setAttribute('visible', 'true');
            this.moveSearchPanelArea.setAttribute('data-raycastable', 'true');
            this.switchBlockingElement(this.searchPanel, false);
        }

        if (this.moveWatchlistTableArea && this.watchlistTable && this.watchlistTable.getAttribute('visible')) {
            this.moveWatchlistTableArea.setAttribute('visible', 'true');
            this.moveWatchlistTableArea.setAttribute('data-raycastable', 'true');
        }

        const moveLegend = document.querySelector('#move-legend-panel-area');
        if (moveLegend) {
            moveLegend.setAttribute('visible', 'true');
            moveLegend.setAttribute('data-raycastable', 'true');
        }
    },
    handleClickFixedButton: function () {
        this.searchPanel = document.querySelector('#search-center-panel');
        this.moveSearchPanelArea = document.querySelector('#move-search-panel-area');

        if (this.moveRightPanelArea) {
            this.moveRightPanelArea.setAttribute('visible', 'false');
            this.moveRightPanelArea.removeAttribute('data-raycastable');
            this.switchBlockingElement(this.rightPanel, true)
        }
        if (this.moveLeftPanelArea) {
            this.moveLeftPanelArea.setAttribute('visible', 'false');
            this.moveLeftPanelArea.removeAttribute('data-raycastable');
            this.switchBlockingElement(this.leftPanel, true)
        }
        if (this.moveDockArea) {
            this.moveDockArea.setAttribute('visible', 'false');
            this.moveDockArea.removeAttribute('data-raycastable');
            this.switchBlockingElement(this.dock, true)
        }
        if (this.moveCentralPanelArea) {
            this.moveCentralPanelArea.setAttribute('visible', 'false');
            this.moveCentralPanelArea.removeAttribute('data-raycastable');
            this.switchBlockingElement(this.centralPanel, true)
        }
        if (this.moveTopMenuArea) {
            this.moveTopMenuArea.setAttribute('visible', 'false');
            this.moveTopMenuArea.removeAttribute('data-raycastable');
        }
        // if (this.moveChartTypeArea) { // Chart Type Handle
        //     this.moveChartTypeArea.setAttribute('visible', 'false');
        //     this.moveChartTypeArea.removeAttribute('data-raycastable');
        // }

        // Search Panel Handle
        if (this.moveSearchPanelArea) {
            this.moveSearchPanelArea.setAttribute('visible', 'false');
            this.moveSearchPanelArea.removeAttribute('data-raycastable');
            this.switchBlockingElement(this.searchPanel, true);
        }

        // Watchlist Table Handle
        this.watchlistTable = document.querySelector('#watchlist-table');
        this.moveWatchlistTableArea = document.querySelector('#move-watchlist-table-area');
        if (this.moveWatchlistTableArea) {
            this.moveWatchlistTableArea.setAttribute('visible', 'false');
            this.moveWatchlistTableArea.removeAttribute('data-raycastable');
        }

        const moveLegend = document.querySelector('#move-legend-panel-area');
        if (moveLegend) {
            moveLegend.setAttribute('visible', 'false');
            moveLegend.removeAttribute('data-raycastable');
        }

        // Ensure state is updated when forcing fixed mode
        if (this.isRepositioning) {
            this.isRepositioning = false;
            this.createSettingsList();
        }
    },
    handleSave: function () {
        this._savePanelPositions();
        this.handleClickFixedButton(); // Exit manual mode
        const cameraRig = document.querySelector('#cameraRig');
        if (cameraRig) cameraRig.emit('update-billboards');
    },
    handleCancel: function () {
        const savedData = getCacheItem(this.PANEL_POSITIONS_KEY);
        if (savedData) {
            this._restorePositionsFromCache(); // Revert to last saved

            const cameraRig = document.querySelector('#cameraRig');
            if (cameraRig) cameraRig.emit('update-billboards-list');
        } else {
            this.handleReset(); // Revert to defaults
        }
        // Reset carousel step to match restored/reset panel positions
        const _memEl = document.querySelector('[main-elements-moving]');
        if (_memEl && _memEl.components['main-elements-moving']) {
            _memEl.components['main-elements-moving'].data.currentStep = 0;
            if (window.VRPanelsSlidingManager) {
                setTimeout(() => window.VRPanelsSlidingManager.resumePanels(), 600);
            }
        }
        this.handleClickFixedButton(); // Exit manual mode
    },
    _savePanelPositions: function () {
        // Refresh references
        this.searchPanel = document.querySelector('#search-center-panel');

        const positions = {};
        const panels = [
            { id: 'rightPanel', el: this.rightPanel },
            { id: 'leftPanel', el: this.leftPanel },
            { id: 'dock', el: this.dock },
            { id: 'centralPanel', el: this.centralPanel },
            { id: 'topMenu', el: this.topMenu },
            { id: 'chartType', el: this.chartType },
            { id: 'searchPanel', el: this.searchPanel },
            { id: 'watchlistTable', el: this.watchlistTable }
        ];

        const legendPanel = document.querySelector('#news-graph-legend-vr');
        if (legendPanel) {
            panels.push({ id: 'legendPanel', el: legendPanel });
        }

        const isNewsGraphActive = document.body.classList.contains('news-graph-active');

        panels.forEach(p => {
            if (p.el) {
                if (p.id === 'dock' && isNewsGraphActive) {
                    const cachedData = getCacheItem(this.PANEL_POSITIONS_KEY);
                    if (cachedData && cachedData.dock) {
                        positions[p.id] = cachedData.dock;
                    } else {
                        positions[p.id] = {
                            position: '-0.14 1.06 -1.75',
                            rotation: '-80 0 0'
                        };
                    }
                } else {
                    positions[p.id] = {
                        position: AFRAME.utils.coordinates.stringify(p.el.getAttribute('position')),
                        rotation: AFRAME.utils.coordinates.stringify(p.el.getAttribute('rotation'))
                    };
                }
            }
        });

        try {
            setCacheItem(this.PANEL_POSITIONS_KEY, positions, this.EXPIRATION_TIME);
            console.log('Saved panel positions:', positions);
        } catch (e) {
            console.warn('Failed to save panel positions', e);
        }
    },
    _restorePositionsFromCache: function () {
        try {
            const data = getCacheItem(this.PANEL_POSITIONS_KEY);
            if (data) {
                this._applyPositions(data);
                console.log('Restored panel positions:', data);
            }
        } catch (e) {
            console.warn('Failed to restore panel positions', e);
        }
    },
    _applyPositions: function (data) {
        if (!data) return;
        const panelMap = {
            'rightPanel': this.rightPanel,
            'leftPanel': this.leftPanel,
            'dock': this.dock,
            'centralPanel': this.centralPanel,
            'topMenu': this.topMenu,
            'chartType': this.chartType,
            'searchPanel': this.searchPanel,
            'watchlistTable': this.watchlistTable,
            'legendPanel': document.querySelector('#news-graph-legend-vr')
        };

        Object.keys(data).forEach(key => {
            const el = panelMap[key];
            const settings = data[key];
            if (el && settings) {
                if (key === 'dock') {
                    const isNewsGraphActive = document.body.classList.contains('news-graph-active');
                    if (isNewsGraphActive) {
                        el.setAttribute('position', '-0.14 -1.06 -1.75');
                        el.setAttribute('scale', '0.001 0.001 0.001');
                        if (settings.rotation) el.setAttribute('rotation', settings.rotation);
                        return;
                    } else {
                        el.setAttribute('scale', '1.05 1.05 1.05');
                    }
                }
                if (settings.position) el.setAttribute('position', settings.position);
                if (settings.rotation) {
                    el.setAttribute('rotation', settings.rotation);
                    if (['centralPanel', 'searchPanel', 'watchlistTable'].includes(key)) {
                        el.setAttribute('expected-panel-rotation', settings.rotation);
                    }
                }
            }
        });

        if (data.chartType && this.chartType) {
            this.chartType.setAttribute('position', data.chartType.position);
            if (data.chartType.rotation) this.chartType.setAttribute('rotation', data.chartType.rotation);
        }
        this.searchPanel = document.querySelector('#search-center-panel');
        if (data.searchPanel && this.searchPanel) {
            this.searchPanel.setAttribute('position', data.searchPanel.position);
            if (data.searchPanel.rotation) {
                this.searchPanel.setAttribute('rotation', data.searchPanel.rotation);
                this.searchPanel.setAttribute('expected-panel-rotation', data.searchPanel.rotation);
            }
        }

        this.watchlistTable = document.querySelector('#watchlist-table');
        if (data.watchlistTable && this.watchlistTable) {
            this.watchlistTable.setAttribute('position', data.watchlistTable.position);
            if (data.watchlistTable.rotation) {
                this.watchlistTable.setAttribute('rotation', data.watchlistTable.rotation);
                this.watchlistTable.setAttribute('expected-panel-rotation', data.watchlistTable.rotation);
            }
            if (this.watchlistTable.components && this.watchlistTable.components['watchlist-table']) {
                const pos = AFRAME.utils.coordinates.parse(data.watchlistTable.position);
                this.watchlistTable.components['watchlist-table'].setCompactMode(Math.abs(pos.x) > 0.4);
            }
        }
    },
    handleReset: function () {
        const panelsToClear = [
            this.centralPanel,
            this.leftPanel,
            this.rightPanel,
            document.querySelector('#search-center-panel'),
            document.querySelector('#watchlist-table')
        ].filter(p => p !== null);

        panelsToClear.forEach(p => {
            p.removeAttribute('animation__rotation');
            p.removeAttribute('animation__position__0');
            p.removeAttribute('animation__position____mmap');

            const banner = p.querySelector('#stock-banner');
            if (banner) banner.removeAttribute('animation__rotation');
            const date = p.querySelector('#current-time-date');
            if (date) date.removeAttribute('animation__rotation');
        });

        if (this.rightPanel) {
            this.rightPanel.setAttribute('position', '0.79 2.2 -2.49');
            this.rightPanel.setAttribute('rotation', '0 -45 0');
            this.rightPanel.setAttribute('expected-panel-rotation', '0 -45 0');
            this.rightPanel.classList.remove('billboard-y');
        }
        if (this.leftPanel) {
            this.leftPanel.setAttribute('position', '-0.8 2.2 -2.5');
            this.leftPanel.setAttribute('rotation', '0 45 0');
            this.leftPanel.setAttribute('expected-panel-rotation', '0 45 0');
            this.leftPanel.classList.remove('billboard-y');
        }
        if (this.dock) {
            const isNewsGraphActive = document.body.classList.contains('news-graph-active');

            this.dock.removeAttribute('animation__position');
            this.dock.removeAttribute('animation__scale');
            this.dock.removeAttribute('animation__rotation');
            this.dock.removeAttribute('animation__position__0');
            this.dock.removeAttribute('animation__scale__0');

            if (isNewsGraphActive) {
                this.dock.setAttribute('position', '-0.14 -1.06 -1.75');
                this.dock.setAttribute('rotation', '-80 0 0');
                this.dock.setAttribute('scale', '0.001 0.001 0.001');
            } else {
                this.dock.setAttribute('position', '-0.14 1.06 -1.75');
                this.dock.setAttribute('rotation', '-80 0 0');
                this.dock.setAttribute('scale', '1.05 1.05 1.05');
            }
        }
        if (this.centralPanel) {
            this.centralPanel.setAttribute('position', '0 1.6 -1.2');
            this.centralPanel.setAttribute('rotation', '0 -45 0');
            this.centralPanel.setAttribute('expected-panel-rotation', '0 -45 0');

            if (this.moveCentralPanelArea) {
                this.moveCentralPanelArea.setAttribute('position', '0 0.49 0.1');
                this.moveCentralPanelArea.setAttribute('rotation', '0 45 0');
            }

            const stockBanner = this.centralPanel.querySelector('#stock-banner');
            if (stockBanner) stockBanner.removeAttribute('animation__rotation');

            const currentTimeDate = this.centralPanel.querySelector('#current-time-date');
            if (currentTimeDate) currentTimeDate.removeAttribute('animation__rotation');
        }
        if (this.topMenu) {
            this.topMenu.setAttribute('position', '-0 3.6 -1.77');
            this.topMenu.setAttribute('rotation', '0 0 0');
        }
        if (this.chartType) {
            this.chartType.setAttribute('position', '-0.02 3.47 -2.66');
            this.chartType.setAttribute('rotation', '30 0 0');
        }
        // Refresh search panel reference before resetting
        this.searchPanel = document.querySelector('#search-center-panel');
        if (this.searchPanel) {
            this.searchPanel.setAttribute('position', '0 2.2 -1.2');
            this.searchPanel.setAttribute('rotation', '0 0 0');
            this.searchPanel.setAttribute('expected-panel-rotation', '0 0 0');
        }

        // Reset Watchlist Table
        this.watchlistTable = document.querySelector('#watchlist-table');
        if (this.watchlistTable) {
            this.watchlistTable.setAttribute('position', '0 2.57 -1.2');
            this.watchlistTable.setAttribute('rotation', '0 0 0');
            this.watchlistTable.setAttribute('expected-panel-rotation', '0 0 0');
            if (this.watchlistTable.components && this.watchlistTable.components['watchlist-table']) {
                this.watchlistTable.components['watchlist-table'].setCompactMode(false);
            }
        }

        const legendPanel = document.querySelector('#news-graph-legend-vr');
        if (legendPanel) {
            legendPanel.setAttribute('position', '2.420 2.80 -1.9');
            legendPanel.setAttribute('rotation', '0 0 0');
        }

        const cameraRig = document.querySelector('#cameraRig');
        if (cameraRig) {
            cameraRig.emit('update-billboards-list');
            cameraRig.emit('update-billboards');
        }

        // Clear saved positions
        try {
            localStorage.removeItem(this.PANEL_POSITIONS_KEY);
            console.log('Cleared panel positions from localStorage');
        } catch (e) {
            console.warn('Failed to clear panel positions', e);
        }

        // Reset carousel step counter so mmap knows we're at center
        const _memEl = document.querySelector('[main-elements-moving]');
        if (_memEl && _memEl.components['main-elements-moving']) {
            _memEl.components['main-elements-moving'].data.currentStep = 0;
            if (window.VRPanelsSlidingManager) {
                setTimeout(() => window.VRPanelsSlidingManager.resumePanels(), 600);
            }
        }

        // Reset mmap wrapper to center-slot state
        const _chartTypeEl = document.querySelector('[chart-type-control]');
        const _isMmapActive = _chartTypeEl?.getAttribute('chart-type-control')?.selectedPrimeAction === 'mmap';
        if (_isMmapActive) {
            const _mmapMode = (window.MarketMapModeSwitching && window.MarketMapModeSwitching.getCurrentMode)
                ? window.MarketMapModeSwitching.getCurrentMode()
                : (typeof getCacheItem === 'function' ? getCacheItem('mmap_view_mode') : null) || '2d';
            if (_mmapMode === '2d') {
                const _mmapWrapper = document.querySelector('#stock-3d-cube-wrapper');
                if (_mmapWrapper) {
                    _mmapWrapper.setAttribute('rotation', '90 45 0');
                    _mmapWrapper.setAttribute('position', '0 0.11 0');
                    // Restore all hidden sectors/bars
                    const _stockCubeEl = document.getElementById('stock-3d-cube');
                    const _vi = _stockCubeEl?.components?.['stock-cube-visualizer'];
                    if (_vi) {
                        _vi.sectorPlatforms?.forEach(sp => {
                            sp.bg?.setAttribute('visible', true);
                            sp.label?.setAttribute('visible', true);
                        });
                        _vi.stockBars?.forEach(barInfo => {
                            barInfo.bar?.setAttribute('visible', true);
                            barInfo.primaryLabel?.setAttribute('visible', true);
                        });
                    }
                }
            }
        }

        this.handleClickFixedButton();
    },
    handleClickARButton: function () {
        if (this.skyboxSphere) {
            this.skyboxSphere.setAttribute('visible', 'false');
        }
    },
    handleClickVRButton: function () {
        if (this.skyboxSphere) {
            this.skyboxSphere.setAttribute('visible', 'true');
        }
    },
    switchBlockingElement: function (element, isEnabled) {
        if (!element) return;
        const blockingPlane = element.querySelector('.blocking-plane');
        if (blockingPlane) {
            blockingPlane.setAttribute('visible', !isEnabled);
            if (isEnabled) {
                blockingPlane.removeAttribute('data-raycastable');
            } else {
                blockingPlane.setAttribute('data-raycastable', '');
            }
        }
    },

    update: function (oldData) {
        const themeChanged = oldData && oldData.themeMode !== this.data.themeMode;

        if (themeChanged) {
            this.replaceModelsToSuitTheme();
            this.suitsTexOfDockPanelForCurrentTheme();
            this.applySettings();

            // Emit theme change event for chart components to listen to
            this.el.sceneEl.emit('theme-changed', {
                themeMode: this.data.themeMode,
                oldThemeMode: oldData.themeMode
            });

            const body = document.querySelector('body');
            if (body) {
                body.classList.remove('light', 'cb-light', 'cb-dark');
                if (this.data.themeMode === 'Light') body.classList.add('light');
            }
        }

        const rotatePanelsModeChanges = oldData && oldData.autoRotatePanels !== undefined && oldData.autoRotatePanels !== this.data.autoRotatePanels;
        console.log('updateRotationMode - update', oldData.autoRotatePanels, this.data.autoRotatePanels)
        if (rotatePanelsModeChanges) {
            this.el.sceneEl.emit('rotate-panels-mode-changed', {
                autoRotatePanels: this.data.autoRotatePanels,
            });
        }

        this.applySettings();
    },

    replaceModelsToSuitTheme: function () {
        const bgBigPanel = document.querySelector('#background-panels .big-panel-model')
        const bgLeftPanel = document.querySelector('#background-panels .left-panel-model')
        const bgRightPanel = document.querySelector('#background-panels .right-panel-model')
        const triangleRightModel = document.querySelector('#right-triangle-arrow-model')
        const triangleLeftModel = document.querySelector('#left-triangle-arrow-model')
        const dock = document.querySelector('#dock .dock-model')
        const noStockMessages = document.querySelectorAll('#right-container .no-stock-selected-message a-rounded-plane')
        const topMenuModel = document.querySelector('#top-menu-container [main-menu-3d]')
        const logoBlack = document.getElementById('logo-black')
        const logoWhite = document.getElementById('logo-white')
        const watchlistText = document.querySelector('#watchlist-button a-troika-text')
        const watchlistIcon = document.querySelector('#watchlist-button a-image')
        const settingsText = document.querySelector('#settings-button a-troika-text')
        const settingsIcon = document.querySelector('#settings-button a-image')
        const loginText = document.querySelector('#login-button a-troika-text')
        const accountIcon = document.querySelector('#account-button-icon')
        const betaText = document.getElementById('beta-text')
        const searchInput = document.getElementById('ticker-search-input')
        const chartTypeTitles = document.querySelectorAll('#top-menu-container .chart-type-title')
        const topPanelTopLevelText = document.querySelectorAll('#top-menu-container .top-level-text-active')
        const zeroPlane = document.querySelector('#zero-plane')
        const chartTitle = document.querySelector('#stock-banner')
        const chartTimeAndDate = document.querySelector('#current-time-date')
        const allPrimaryLabels = document.querySelectorAll('#stock-3d-cube .primary-label')
        const primaryLabelStyle = window.StockCubeVR && window.StockCubeVR.platformConfig &&  window.StockCubeVR.platformConfig.primaryLabelStyle
        const chartType = document.querySelector('#chart-type-control .model-3d')

        if (this.data.themeMode === 'Dark') {
            if (chartType) chartType.setAttribute('gltf-model', '#chart-type-model');
            if (logoBlack) logoBlack.setAttribute('visible', 'false');
            if (logoWhite) logoWhite.setAttribute('visible', 'true');
            noStockMessages.forEach(msg => {
                msg.setAttribute('color', '#222');
            })
            if (zeroPlane) zeroPlane.setAttribute('material', 'color','#666');
        } else {
            if (chartType) chartType.setAttribute('gltf-model', '#chart-type-light-model');
            if (logoBlack) logoBlack.setAttribute('visible', 'true');
            if (logoWhite) logoWhite.setAttribute('visible', 'false');
            noStockMessages.forEach(msg => {
                msg.setAttribute('color', '#ababab');
            })
            if (zeroPlane) zeroPlane.setAttribute('material', 'color','#fff');
        }

        const isMobile = /(iPhone|iPad|iPod|Android|Mobi|Tablet)/i.test(navigator.userAgent);
        let currentQuality = this.data.quality ? this.data.quality : (isMobile ? 'performance' : 'quality');
        
        if (currentQuality === 'quality') {
            if (triangleRightModel) triangleRightModel.setAttribute('gltf-model', '#triangle-arrow-model');
            if (triangleLeftModel) triangleLeftModel.setAttribute('gltf-model', '#triangle-arrow-model');
        } else {
            if (triangleRightModel) triangleRightModel.setAttribute('gltf-model', '#triangle-arrow-ne-model');
            if (triangleLeftModel) triangleLeftModel.setAttribute('gltf-model', '#triangle-arrow-ne-model');
        }
        
        if (this.data.themeMode === 'Dark' && currentQuality === 'quality') {
            if (bgBigPanel) bgBigPanel.setAttribute('gltf-model', '#central-bg-model');
            if (bgLeftPanel) bgLeftPanel.setAttribute('gltf-model', '#side-panel-model');
            if (bgRightPanel) bgRightPanel.setAttribute('gltf-model', '#side-panel-model');
            if (dock) dock.setAttribute('gltf-model', '#dock-model');
            if (topMenuModel) topMenuModel.setAttribute('gltf-model', '#top-panel-model');
            if (chartTitle) chartTitle.setAttribute("outline-opacity", '1');
            if (chartTimeAndDate) chartTimeAndDate.setAttribute("outline-opacity", '1');
            if (primaryLabelStyle) primaryLabelStyle.outlineOpacity = 1;
            allPrimaryLabels.forEach(label => label.setAttribute('outline-opacity', '1'))
        }
        if (this.data.themeMode === 'Dark' && currentQuality === 'performance') {
            if (bgBigPanel) bgBigPanel.setAttribute('gltf-model', '#central-bg-ne-model');
            if (bgLeftPanel) bgLeftPanel.setAttribute('gltf-model', '#side-panel-ne-model');
            if (bgRightPanel) bgRightPanel.setAttribute('gltf-model', '#side-panel-ne-model');
            if (dock) dock.setAttribute('gltf-model', '#dock-ne-model');
            if (topMenuModel) topMenuModel.setAttribute('gltf-model', '#top-panel-ne-model');
            if (chartTitle) chartTitle.setAttribute("outline-opacity", '1');
            if (chartTimeAndDate) chartTimeAndDate.setAttribute("outline-opacity", '1');
            if (primaryLabelStyle) primaryLabelStyle.outlineOpacity = 1;
            allPrimaryLabels.forEach(label => label.setAttribute('outline-opacity', '1'))
        }
        if (this.data.themeMode === 'Light' && currentQuality === 'quality') {
            if (bgBigPanel) bgBigPanel.setAttribute('gltf-model', '#central-bg-light-model');
            if (bgLeftPanel) bgLeftPanel.setAttribute('gltf-model', '#side-panel-with-border-light-model');
            if (bgRightPanel) bgRightPanel.setAttribute('gltf-model', '#side-panel-with-border-light-model');
            if (dock) dock.setAttribute('gltf-model', '#dock-light-model');
            if (topMenuModel) topMenuModel.setAttribute('gltf-model', '#top-panel-light-model');
            if (chartTitle) chartTitle.setAttribute("outline-opacity", '1');
            if (chartTimeAndDate) chartTimeAndDate.setAttribute("outline-opacity", '1');
            if (primaryLabelStyle) primaryLabelStyle.outlineOpacity = 1;
            allPrimaryLabels.forEach(label => label.setAttribute('outline-opacity', '1'))
        }
        if (this.data.themeMode === 'Light' && currentQuality === 'performance') {
            if (bgBigPanel) bgBigPanel.setAttribute('gltf-model', '#central-bg-ne-light-model');
            if (bgLeftPanel) bgLeftPanel.setAttribute('gltf-model', '#side-panel-with-border-ne-light-model');
            if (bgRightPanel) bgRightPanel.setAttribute('gltf-model', '#side-panel-with-border-ne-light-model');
            if (dock) dock.setAttribute('gltf-model', '#dock-ne-light-model');
            if (topMenuModel) topMenuModel.setAttribute('gltf-model', '#top-panel-ne-light-model');
            if (chartTitle) chartTitle.setAttribute("outline-opacity", '0.3');
            if (chartTimeAndDate) chartTimeAndDate.setAttribute("outline-opacity", '0.3');
            if (primaryLabelStyle) primaryLabelStyle.outlineOpacity = 0.6;
            allPrimaryLabels.forEach(label => label.setAttribute('outline-opacity', '0.6'))
        }

        // Update top menu button text colors (Search / Watchlist / Settings / Login)
        const menuTextColor = this.data.themeMode === 'Light' ? '#14141C' : '#FFFFFF';
        [watchlistText, watchlistIcon, settingsText, settingsIcon, loginText, accountIcon, betaText,
            ...chartTypeTitles, ...topPanelTopLevelText].forEach(el => {
                if (el) el.setAttribute('color', menuTextColor);
            });
        const potentiallyActiveElement = document.querySelector('#top-menu-container .top-level-text-can-be-active');
        if (potentiallyActiveElement) potentiallyActiveElement.setAttribute('active-color', menuTextColor);

        // Also update the HTML search input text color to match the theme
        if (searchInput) {
            searchInput.style.color = menuTextColor;
        }
    },

    suitsTexOfDockPanelForCurrentTheme: function () {
        const newColor = this.data.themeMode === 'Dark' ? '#AAA' : '#111';

        const timelineElements = document.querySelectorAll('#dock .timeline-text');
        if (timelineElements) {
            timelineElements.forEach(el => el.setAttribute('color', newColor));
        }

        const rotationText = document.querySelector('#dock .rotation-text');
        if (rotationText) {
            rotationText.setAttribute('color', newColor);
        }
    },

    _updateConfigureControlSettings: function (stockBarsTexturesValue) {
        try {
            const configureSettings = getCacheItem('configureControlSettings') || {};
            configureSettings.stockBarsTextures = stockBarsTexturesValue;
            setCacheItem('configureControlSettings', configureSettings, this.EXPIRATION_TIME);
            console.log('[Main Settings] Updated stockBarsTextures in configureControlSettings:', stockBarsTexturesValue);

            const configureControlEl = document.querySelector('[configure-control]');
            if (configureControlEl && configureControlEl.components && configureControlEl.components['configure-control']) {
                configureControlEl.setAttribute('configure-control', 'stockBarsTextures', stockBarsTexturesValue);
            }
        } catch (e) {
            console.warn('[Main Settings] Failed to update configureControlSettings:', e);
        }
    },


    open: function () {
        console.log('MainSettings: open() called');
        this.createHeader();
        this.createSettingsList();

        // Ensure visible is true (redundant if called via PopupManager, but good for standalone)
        if (!this.el.getAttribute('visible')) {
            this.el.setAttribute('visible', true);
        }
    },

    close: function () {
        console.log('MainSettings: close() called');
        // Prevent auto-regeneration of list by manually disabling repositioning flag first
        if (this.isRepositioning && !this._switchingToRepoPopup) {
            this.isRepositioning = false;
        }
        if (!this._switchingToRepoPopup) {
            this.handleClickFixedButton(); // Reset any active repositioning
        }

        this.el.setAttribute('visible', false);

        // Clear content to remove hitboxes
        setTimeout(() => {
            const contentElement = this.el.querySelector('#main-settings-content');
            if (contentElement) {
                contentElement.innerHTML = '';
            }
            // Clear header to remove header hitboxes
            const headerContainer = this.el.querySelector('#main-settings-header');
            if (headerContainer) {
                headerContainer.innerHTML = '';
            }
        }, 50);
    }
});
